export default __webpack_public_path__ + "static/media/panierBioService.e57feb15.png";